import forms from "../_ApiConn/apiForms";

// מחזיר את גוף התגובה: { errMsg, data }  (data = הטופס עצמו, או { closed, title })
const getBySlug = async (slug) => {
    let dFromF = await forms.getBySlug(slug);
    return (dFromF.data);
};

// מחזיר { errMsg, ok }
const submit = async (slug, body) => {
    let dFromF = await forms.submit(slug, body);
    return (dFromF.data);
};

export default {
    getBySlug,
    submit,
};
